<template>
	<v-col v-bind="$attrs">
		<slot />
	</v-col>
</template>
<script>
	export default {
		name: "c-col",

		components: {},
		data () {
			return {};
		},
		computed: {},
		watch: {},
		created () {
		},
		mounted () {
		},
		updated () {
		},
		destroyed () {
		},

		methods: {},
	};
</script>

<style scoped>

</style>
